import { render, staticRenderFns } from "./CourseDetailPerformance.vue?vue&type=template&id=7e55cf6e&scoped=true&"
import script from "./CourseDetailPerformance.vue?vue&type=script&lang=js&"
export * from "./CourseDetailPerformance.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailPerformance.vue?vue&type=style&index=0&id=7e55cf6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e55cf6e",
  null
  
)

export default component.exports